<template>
  <v-dialog persistent @click:outside="close" v-model="value" :width="500">
    <v-card>
      <v-btn icon small @click="close" absolute right class="mt-4">
        <v-icon small>fas fa-times</v-icon>
      </v-btn>
      <v-card-text class="text-center">
        <MyUzcardForm
            ref="form"
            v-if="isCardTypeUzcard"
            @done="close"
            @save="$emit('save', $event)"
            :mko_id="mko_id"
            :user_id="user_id"
        />
        <OtherCardForm
            @save="$emit('save', $event)"
            @done="close"
            ref="form"
            v-else
            :mko_id="mko_id"
            :user_id="user_id"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>


import OtherCardForm from "@/components/card/OtherCardForm";
import MyUzcardForm from "@/components/card/MyUzcardForm";

export default {
  name: 'create-card-dialog',
  components: {MyUzcardForm, OtherCardForm},
  props: {
    value: {},
    mko_id: {},
    user_id: {},
    isCardTypeUzcard: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value(val) {
      const {form} = this.$refs
      if (!val && form) {
        form.clearCardForm()
      }
    }
  },
  methods: {
    close() {
      this.$emit('input', false)
    },
  },
}
</script>
